import { SummaryRow, SummaryRowPlaceholder } from './summarySection.styles';

/**
 * MPH-1144: Figma's loading state for a trip overview section (hotel or transport) — three
 * icon-less lines, since which rows the loaded section shows, and their icons, are only known
 * once the rate or the transport resolves. Rendered inside SummaryRows.
 */
export function SummaryRowsSkeleton({ firstLineWidth = '72%' }: { firstLineWidth?: string }) {
  return (
    <>
      <SummaryRow>
        <SummaryRowPlaceholder width={firstLineWidth} />
      </SummaryRow>
      <SummaryRow>
        <SummaryRowPlaceholder width="72%" />
      </SummaryRow>
      <SummaryRow>
        <SummaryRowPlaceholder width="72%" />
      </SummaryRow>
    </>
  );
}
